import {
  CampModel,
  ClientModel,
  CompanyModel,
  EnterpriseModel,
  SiteModel,
  UserModel,
} from '../../central/model'
import {
  getCamp,
  getClient,
  getCompany,
  getContract,
  getEnterprise,
  getModule,
  getSite,
  getUser,
} from '../../central/services'
import {MasterFiltersDto} from '../features/modules/models'
import {getMasterModuleService} from '../features/modules/services'
import {ContractModel} from '../models/central.model'

export const useCentralServices = () => {
  const getCompanies = async (filters: CompanyModel, page: number) => {
    try {
      const response = await getCompany(filters, page)
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.id,
        label: item.nombreEmpresa,
      }))
      const filteredData = mappedSites.filter((item) => item.value !== '4EsB2NAAsDA=')
      return filteredData
    } catch (error) {
      console.log('getCompanies error', error)
      return []
    }
  }

  const getEnterprises = async (filters: EnterpriseModel, page: number) => {
    try {
      const response = await getEnterprise(filters, page)
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.id,
        label: item.nombre,
      }))
      const filteredData = mappedSites.filter((item) => item.value !== '4EsB2NAAsDA=')
      return filteredData
    } catch (error) {
      console.log('getCompanies error', error)
      return []
    }
  }

  const getClients = async (filters: ClientModel, page: number) => {
    try {
      const response = await getClient(filters, page)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const filteredData = mappedSites.filter((item) => item.value !== '4EsB2NAAsDA=')
      return filteredData
    } catch (error) {
      console.log('getClients error', error)
      return []
    }
  }

  const getSites = async (filters: SiteModel, page: number) => {
    try {
      const response = await getSite(filters, page)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const filteredData = mappedSites.filter((item) => item.value !== '4EsB2NAAsDA=')

      return filteredData
    } catch (error) {
      return []
    }
  }

  const getCamps = async (filters: CampModel, page: number) => {
    try {
      const response = await getCamp(filters, page)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      const filteredData = mappedSites.filter((item) => item.value !== '4EsB2NAAsDA=')

      return filteredData
    } catch (error) {
      return []
    }
  }

  const getUsers = async (filters: UserModel, page: number) => {
    try {
      const response = await getUser(filters, 1)
      const data = response.data.data
      const mappedUsers = data?.map((user) => ({
        value: user.id,
        label: `${user.nombres || ''} ${user.apellidos || ''} ${user.numeroDocumento || ''}`,
      }))
      return mappedUsers
    } catch (error) {
      return []
    }
  }

  const getReceptionist = async (
    filters: ContractModel,
    page: number,
    empresaId: boolean = false,
  ) => {
    try {
      const response = await getContract(filters, page)
      const data = response.data.data
      const mappedReceptionist = data?.map((rec) => ({
        value: empresaId ? rec.empresaId : rec.id,
        label: rec.nombreEmpresa,
      }))
      return mappedReceptionist
    } catch (error) {
      return []
    }
  }

  const getDocumentTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getDocumentTypesByCode = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getApplications = async () => {
    try {
      const response = await getModule({}, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.id || '',
        label: item.nombre || '',
        ...item,
      }))
      return mappedSites
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getParametersStatus = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoParamFacturacion',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getMoneda = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'Moneda',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getUnidadParameter = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'UnidadParamFacturacion',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
        ...master,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getMasterTable = async (table: string, type: boolean, filters: MasterFiltersDto = {}) => {
    try {
      const response = await getMasterModuleService(
        {
          pageNumber: 1,
          size: 100,
          tableName: table,
        },
        filters,
      )
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: type ? master.id : master.codigo,
        label: master.nombreCorto,
        ...master,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  return {
    getCompanies,
    getClients,
    getSites,
    getCamps,
    getUsers,
    getDocumentTypes,
    getEnterprises,
    getApplications,
    getParametersStatus,
    getMoneda,
    getUnidadParameter,
    getDocumentTypesByCode,
    getMasterTable,
    getReceptionist,
  }
}
